import { render, staticRenderFns } from "./FoldableListItem.vue?vue&type=template&id=64247e05&"
import script from "./FoldableListItem.vue?vue&type=script&lang=js&"
export * from "./FoldableListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports